import { MapObject } from "@iventis/domain-model/model/mapObject";
import { RepeatedTimeRange } from "@iventis/domain-model/model/repeatedTimeRange";
import { Feature, Polygon, Point, LineString } from "geojson";

export type PostImportedGeoJsonMapObject = Omit<
    MapObject,
    "level" | "createdByUserId" | "createdAt" | "createdByUserName" | "lastUpdatedByUserId" | "lastUpdatedByUserName" | "lastUpdatedAt" | "geoJsonFeature"
> & {
    geoJsonFeature: Feature<Polygon | Point | LineString>;
};

export type SupportedGeojsonPropertyTypes = boolean | string | number | RepeatedTimeRange[];
